module.exports = __webpack_public_path__ + "assets/Cannerald_Shop_Icon-Zubehör.8f6f64f2.svg";